import { createRouter, createWebHashHistory, RouteRecordRaw } from 'vue-router'
import NqrView from '@/views/NqrView.vue'

const routes: Array<RouteRecordRaw> = [
  {
    path: '/',
    name: 'nqr',
    component: NqrView
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
